import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { cardDriverFactory } from './Card.driver';
import { Card } from '.';

const TestComp: React.FC<any> = (props) => (
  <Card {...props}>
    <Card.Container>test</Card.Container>
    <Card.Container>test</Card.Container>
  </Card>
);

describe('Card', () => {
  const createDriver = createRendererWithUniDriver(cardDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<TestComp />);
    expect(await driver.exists()).toBe(true);
  });

  it('should have stacked state', async () => {
    const { driver } = createDriver(<TestComp stacked />);
    expect(await driver.isStacked()).toBe(true);
  });
});
